// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  anioCurso: '0',
  periodoCurso: '0',
  baseUrlAPI: 'https://portalapi.tuni.pe',
  //baseUrlAPIDWH: 'https://siudockerdesa.sunedu.gob.pe/tuni-dwh/api', //PRE-QA
  baseUrlAPIDWH: '',//'http://localhost:59066/api', // DESA
  //baseUrlAPIDWH: 'https://portalapiqa.sunedu.gob.pe/ApiDatos/api', // QA
  baseUrlAPIEXT: '',//'https://siudockerdesa.sunedu.gob.pe/tuni-externo/swagger',
  keys: {
    encrypt: 'D3923BDE-C58B-4F4A-8DAC-E9F301CDB8FD',
    GOOGLE_MAPS_API: 'AIzaSyAvAVA00huj1q3u0N4x6uUH1V8qjSUNyWM',
    GOOGLE_RECAPTCHA: '6LcY9XscAAAAADtd00npJNau36D49ZGOMM8fGncM',
    GA_CODE: 'UA-154360733-1',
    //JWT: 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VybmFtZSI6InN1bjNkdV9zMXVAdXNlcjIwMTkiLCJleHAiOjE1ODUxMTI0MDAsImlzcyI6Imh0dHBzOi8vd3d3LnN1bmVkdS5nb2IucGUvIiwiYXVkIjoic3VuZWR1In0.JxLdpSc68aM2tjMz1xGTY8tzCTFf1ag-8-eU97MzDDY'
  },
  urls: {
    GOOGLE_MAPS_API: 'https://maps.googleapis.com/maps/api/js?libraries=places&key=',
    PORTAL_IMAGENES: '',//'https://siudockerdesa.sunedu.gob.pe/tuni-dwh/api/imagen?img='
  },
  microsoft: {
    scopeUri: ['api://e08d10eb-f42c-4fb6-9436-8785730a63a3/TuniApi2.1'],
    tenantId: '01ecb846-9889-46e1-b9a8-cee202e0487b',
    uiClienId: '1c539387-bbc2-4067-b95c-6a1388b662ed',
    redirectUrl: '',//'http://localhost:4200/estadistica'
  },
  versionEncuesta: 1
};
/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
